import { setupAxios } from '../app/modules/auth';
import { API_BASE_URL } from '../utils/contants';

//  GET NOTIFICATIONS
export async function getNotificationsAPI(userId: string) {
  const { token, tenantId } = setupAxios();

  const res = await fetch(`${API_BASE_URL}/notifications/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  });

  return await res.json();
}

//  MARK AS READ
export async function markAsReadAPI(id: string, requireSuccess = false) {
  const { token, tenantId } = setupAxios();

  const res = await fetch(`${API_BASE_URL}/notifications/read/${id}`, {
    method: 'PUT',
    headers: {
      // 'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  });

  const response = await res.json();
  if (requireSuccess && (!res.ok || response?.success !== true)) {
    throw new Error(response?.message || 'Unable to mark this notification as read. Please try again.');
  }
  return response;
}

export async function clearNotificationsAPI(userId: string) {
  const { token, tenantId } = setupAxios();

  return fetch(`${API_BASE_URL}/notifications/clear/${userId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "X-tenant-Id": `${tenantId}`,
    },
  });
}

export async function deleteNotificationAPI(id: string) {
  const { token, tenantId } = setupAxios();

  return fetch(`${API_BASE_URL}/notifications/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "X-tenant-Id": `${tenantId}`,
    },
  });
}

export async function getUnreadEmployeeCommunicationCountAPI(userId: string) {
  const { token, tenantId } = setupAxios();

  const res = await fetch(`${API_BASE_URL}/notifications/unread-count/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  });

  return await res.json();
}

export async function markEmployeeCommNotificationsAsReadAPI(userId: string) {
  const { token, tenantId } = setupAxios();

  const res = await fetch(`${API_BASE_URL}/notifications/mark-employee-comm-read/${userId}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  });

  return await res.json();
}
